import { c as _c } from "react/compiler-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import CtaButton from 'components/essentials/Cta/CtaButton';
import NotificationBannerSkeleton from './NotificationBannerSkeleton';
const WelcomeBack = t0 => {
  const $ = _c(11);
  const {
    firstName,
    wishListProduct,
    onClose
  } = t0;
  const t1 = `Welcome to Joybird ${firstName}!`;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <span>Start a wishlist, checkout faster and track your orders, what more could you ask for?</span>;
    $[0] = t2;
  } else {
    t2 = $[0];
  }
  let t3;
  if ($[1] !== onClose || $[2] !== t1) {
    t3 = <NotificationBannerSkeleton title={t1} body={t2} onClose={onClose} />;
    $[1] = onClose;
    $[2] = t1;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== firstName || $[5] !== onClose || $[6] !== wishListProduct) {
    t4 = wishListProduct ? <NotificationBannerSkeleton modifier="second" title={`Welcome to Joybird ${firstName}!`} body={<><span>{wishListProduct ? `The ${wishListProduct || "product"} has been` : "We missed you!"}{" "}</span><span className="[&_button]:p-0 [&_button]:ml-[5px]"><Link to={wishListProduct ? "/wishlist/" : "/customer/dashboard/"}><CtaButton styling="link" color="brand" size="sm" hasArrow={true} block={true} noLinkPadding={true}>{wishListProduct ? "saved to your wishlist" : "Go to your dashboard"}</CtaButton></Link></span></>} onClose={onClose} /> : null;
    $[4] = firstName;
    $[5] = onClose;
    $[6] = wishListProduct;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== t3 || $[9] !== t4) {
    t5 = <>{t3}{t4}</>;
    $[8] = t3;
    $[9] = t4;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  return t5;
};
WelcomeBack.propTypes = {
  firstName: PropTypes.string,
  wishListProduct: PropTypes.string,
  onClose: PropTypes.func
};
export default WelcomeBack;